export default __webpack_public_path__ + "static/media/downtown-coverpic.80624ae1.svg";